import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import * as actions from 'Actions';
import MediaBreakpoints from 'Utils/MediaBreakpoints';
import { selectCheckPermission } from 'HelperFunctions/locations';
import MobileSignedInNav from './MobileSignedInNav';
import MessagesTab from './MessagesTab';
import { cpHostName } from 'HelperFunctions/locations';
import { setMultilocationAllLocations } from 'Actions/dashboardActionCreators';
import { storefrontSettingLocked } from 'HelperFunctions/storefrontSettingAccessibility';
import {
  ArrowUp,
  ArrowDown,
  CheckingIn,
  CheckingOut,
  AddCircle,
  Team,
  Company,
  Venue,
  Items,
  Accessories,
  Addons,
  TickMark,
  Bundles,
  Count,
  Barcode,
  Maintenance,
  AllRentals,
  Pending,
  Quotes,
  Reservations,
  CheckedOut,
  CheckedIn,
  Closed,
  Cancelled,
  Drafts,
  Templates,
  Export,
  Calendar,
  Profit,
  Receipt,
  Business,
  RentalSettings,
  Connect,
  WithSubRentals,
  Payment,
  Email,
  LegalDocument,
  Alert,
  Roles,
  TruckDropOff,
  Map,
  GpsMarker,
  Layout,
  Styling,
  Pages,
  MenuIcon,
  MessageBubble,
  ThumbsUp,
  Footer,
  NowstaLogo,
  QuickbooksCircle,
  CartIcon,
  OrderBag,
  Zapier,
  Contacts,
  Clock,
  Proposals,
  Print,
  PurchaseOrderFilled,
} from 'Utils/SvgIcons';
import Imgix from 'react-imgix';
import ScrollArea from 'Utils/react-scrollbar';
import { paymentsUrl } from 'HelperFunctions/urls';
import { reportLinkColumns } from 'HelperFunctions/menuLinkHelper';
import { getDashboardNavLinkPath } from '../utils/AtAGlanceLink';
import converter from 'json-style-converter/es5';
import { PERMISSION_ERROR_MESSAGES } from 'HelperFunctions/permissions';
import { useApolloClient } from '@apollo/client';
import { pickListManagerFeatureName } from '../../helper_functions/pickListFunctions';
import { BlueClock } from '../utils/SvgIcons';
import originalTerminologies from '../../helper_functions/originalTerminologies';
import { useTheme } from 'styled-components';
import Toggle from 'material-ui/Toggle';
import { whiteToggleStyles } from '../utils/styles/toggleStyles';
import { setQuickView } from '../../actions/QuickViewActions';
import QuickViewModal from '../rentals/QuickViewModal/QuickViewModal';
import {
  isRentalsV2Path,
  isRentalCreationOrEditPath,
} from '../../helper_functions/urls/isRentalV2Path';
import {
  isRentalDetailPath,
  isRentalPaymentsPath,
  extractRentalIdFromPath,
  buildRentalPaymentsPath,
} from '../../helper_functions/urls/isRentalInfoPath';
import { store } from 'Utils/redux/store';

const SignedInNav = ({
  history,
  business,
  location,
  user,
  signOutUser,
  checkPermission,
  employeeLocationRelationship,
  multilocationAllLocations,
  fetchNotificationAllCount,
  setMultilocationAllLocations,
  fetchTerminologies,
  fetchOriginalTerminologies,
  setNewUser,
  setErrors,
  sendChurnZeroEvent,
  switchLocation,
  isQuickView,
  businessLocation,
  setQuickView,
}) => {
  const [mobile, setMobile] = useState({ open: false });
  const [events, setEvents] = useState({ open: false });
  const [inventory, setInventory] = useState({ open: false });
  const [contacts, setContacts] = useState({ open: false });
  const [operations, setOperations] = useState({ open: false });
  const [admin, setAdmin] = useState({ open: false });
  const [profile, setProfile] = useState({ open: false });
  const [businesses, setBusinesses] = useState({ open: false });
  const [client, setClient] = useState(useApolloClient());
  const [locationSearchValue, setLocationSearchValue] = useState('');
  const [isQuickViewModalOpen, setQuickViewModalOpen] = useState(false);

  const theme = useTheme();

  useEffect(() => {
    let locationId = store.getState().location.location.id;
    store.subscribe(() => {
      let newLocationId = store.getState().location.location.id;
      if (locationId != newLocationId) {
        locationId = newLocationId;
        fetchTerminologies(false, locationId);
        fetchOriginalTerminologies(false);
      }
    });
  }, []);

  useEffect(() => {
    const { pathname } = location;

    // Don't redirect if we're on a V2 rental path
    if (isQuickView && isRentalDetailPath(pathname) && !isRentalsV2Path()) {
      const rentalId = extractRentalIdFromPath(pathname);
      if (rentalId) {
        history.push(buildRentalPaymentsPath(rentalId));
      }
    }
  }, [location.pathname, isQuickView]);

  const handleCloseQuickViewModal = () => {
    setQuickViewModalOpen(false);
    history.push('/orders/rentals/new?is_quick_quote=true', {
      fromQuickView: true,
    });
  };

  const handleQuickViewToggle = (event, isInputChecked) => {
    setQuickView(isInputChecked);
    const { pathname } = location;
    const isRentalFormPath = isRentalCreationOrEditPath(pathname);

    const isTemplatePath = pathname.includes('/orders/rentals/v2/newTemplate');

    if (isInputChecked) {
      if (isTemplatePath) {
        // If we're on the template creation page, redirect to new rental form
        setQuickViewModalOpen(true);
      } else if (isRentalFormPath) {
        // If we're on other rental form pages, do nothing
        return;
      } else {
        // Check if we're on a valid rental detail page with a specific rental ID
        const rentalId = extractRentalIdFromPath(pathname);
        if (rentalId && !isRentalPaymentsPath(pathname)) {
          // If we're on a rental detail page but not the payments page, go to payments
          history.push(buildRentalPaymentsPath(rentalId));
        } else if (!rentalId) {
          // If we're not on a specific rental page, show the Quick Quote modal
          setQuickViewModalOpen(true);
        }
      }
    } else {
      const url = new URL(window.location.href);
      if (url.searchParams.get('is_quick_quote')) {
        url.searchParams.delete('is_quick_quote');
        history.push(url.pathname + url.search);
      }
    }
  };

  const mobileSignOut = () => {
    toggleMobile();
    signOutUser();
  };

  const toggleMobile = () => {
    setMobile({ open: !mobile.open });
  };

  const shouldRender = () => {
    return checkPermission('operations_view');
  };

  const determineOffset = (menu) => {
    let offset = 0;
    switch (menu) {
      case 'events':
        offset++;
      /* falls through */
      case 'inventory':
        if (
          employeeLocationRelationship?.roleKeys?.includes('devops') &&
          (checkPermission('view_inventory') ||
            checkPermission('edit_add_inventory'))
        ) {
          offset++;
        }
      /* falls through */
      case 'contacts':
        if (
          checkPermission('view_contacts') ||
          checkPermission('edit_add_contacts')
        ) {
          offset++;
        }
      /* falls through */
      case 'operations':
        offset++;
      /* falls through */
      case 'admin':
        if (
          checkPermission('view_reports') ||
          checkPermission('view_edit_settings')
        ) {
          offset++;
        }
      /* falls through */
      case 'messages':
        offset++;
      /* falls through */
      default:
    }
    return 'offset' + offset;
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    switch (name) {
      case 'mobile':
        setMobile(value);
        break;
      case 'events':
        setEvents(value);
        break;
      case 'inventory':
        setInventory(value);
        break;
      case 'contacts':
        setContacts(value);
        break;
      case 'operations':
        setOperations(value);
        break;
      case 'admin':
        setAdmin(value);
        break;
      case 'profile':
        setProfile(value);
        break;
      case 'businesses':
        setBusinesses(value);
        break;
      case 'client':
        setClient(value);
        break;
    }
  };

  const toggleEventsMenu = (event) => {
    setEvents({
      open: !events.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveEventsMenu = (event) => {
    setEvents({
      open: false,
    });
  };

  const toggleInventoryMenu = (event) => {
    setInventory({
      open: !inventory.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveInventoryMenu = (event) => {
    setInventory({
      open: false,
    });
  };

  const toggleContactsMenu = (event) => {
    setContacts({
      open: !contacts.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveContactsMenu = (event) => {
    setContacts({
      open: false,
    });
  };

  const toggleOperationsMenu = (event) => {
    setOperations({
      open: !operations.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveOperationsMenu = (event) => {
    setOperations({
      open: false,
    });
  };

  const toggleAdminMenu = (event) => {
    setAdmin({
      open: !admin.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveAdminMenu = (event) => {
    setAdmin({
      open: false,
    });
  };

  const toggleProfileMenu = (event) => {
    setProfile({
      open: !profile.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveProfileMenu = (event) => {
    setProfile({
      open: false,
    });
  };

  const toggleBusinessesMenu = (event) => {
    setBusinesses({
      open: !businesses.open,
      anchorEl: event.currentTarget,
    });
  };
  const leaveBusinessesMenu = (event) => {
    setBusinesses({
      open: false,
    });
  };

  const selectAllLocations = (businessId) => {
    setMultilocationAllLocations(true);
    fetchNotificationAllCount(true);
    if (
      !window.location.pathname.startsWith('/todos') &&
      !window.location.pathname.startsWith('/dashboard') &&
      !window.location.pathname.startsWith('/payments')
    )
      history.push('/todos');
  };

  const selectBusiness = (locationId, businessId) => {
    switchLocation(locationId, businessId);
    history.push('/todos');
  };

  const addNewBusiness = () => {
    setNewUser({ ...user, software_tier: 'all' });
    window.open('/start', '_blank');
  };

  const permissionGate = (event, permission, errorMessage) => {
    if (!checkPermission(permission)) {
      event.preventDefault();
      setErrors(errorMessage);
    }
  };

  const myProfileSupportOnClick = () => {
    const eventName = 'My Profile Support Clicked';
    sendChurnZeroEvent(eventName);
  };

  const renderLinks = (links) => {
    let linkList = links.map((reportLink, reportIndex) => (
      <li key={reportLink.id ?? reportIndex} name={reportLink.name}>
        <Link
          to={reportLink.to}
          id={`nav_admin_reports_${
            reportLink.id ?? converter.camelToSnakeCase(reportLink.to)
          }`}
        >
          {reportLink.icon}
          {reportLink.name}
        </Link>
      </li>
    ));

    const protectedStuff = [
      'Payments',
      'Sales Tax',
      'Profit',
      'Best Customers',
      'Popular Items',
      'Inventory',
      'Total Order Volume',
      'Commission',
      'Revenue',
      'General Ledger',
      'Tapwise',
    ];

    if (!checkPermission('access_quickbooks_connection_page_reports'))
      linkList = linkList.filter((l) => l.props.name !== 'QuickBooks');
    if (!checkPermission('export_reports'))
      linkList = linkList.filter((l) => !protectedStuff.includes(l.props.name));

    return linkList;
  };

  const {
    venuePlural,
    venueSingular,
    parentOrderSingular,
    checkedInSingular,
    checkedOutSingular,
    checkingInSingular,
    checkingOutSingular,
  } = originalTerminologies();

  const { locations } = user;

  const creditTermsEnabled = business.permissions.creditTermsEnabled;
  const otherLocations = locations.filter(
    (l) => multilocationAllLocations || l.id !== businessLocation.id
  );

  const propertyHasSearchValue = (property) =>
    property.toLowerCase().includes(locationSearchValue.toLowerCase());

  const filteredLocations = otherLocations.filter((l) => {
    return locationSearchValue?.length
      ? propertyHasSearchValue(l.name) || propertyHasSearchValue(l.locationCode)
      : l;
  });

  const canViewMultilocation =
    checkPermission('view_edit_ml_settings') ||
    checkPermission('view_edit_ml_team') ||
    checkPermission('view_edit_ml_locations') ||
    checkPermission('view_edit_ml_account');

  return (
    <MediaBreakpoints
      desktop={
        <div className='header'>
          <div className='mainMenu'>
            {otherLocations.length === 0 && (
              <Link to='/todos'>{businessLocation.name}</Link>
            )}
            {otherLocations.length > 0 && (
              <div
                className='companySelect'
                onMouseEnter={toggleBusinessesMenu}
                onMouseLeave={leaveBusinessesMenu}
                onClick={toggleBusinessesMenu}
              >
                {multilocationAllLocations ? (
                  <Link to='/todos'>{business.name} (All Locations)</Link>
                ) : (
                  <Link to='/todos'>
                    {businessLocation.locationCode && (
                      <span
                        className='badge'
                        style={{
                          backgroundColor:
                            businessLocation.locationColor || theme.darkGray,
                        }}
                      >
                        {businessLocation.locationCode}
                      </span>
                    )}
                    {businessLocation.name}
                  </Link>
                )}
                {businesses.open ? <ArrowUp /> : <ArrowDown />}
                {businesses.open && (
                  <div className='subMenu'>
                    <div>
                      <div>
                        <h4>My Accounts</h4>
                      </div>
                      <ScrollArea speed={0.8} horizontal={false}>
                        <input
                          value={locationSearchValue}
                          className='searchInput'
                          type='search'
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) =>
                            setLocationSearchValue(e.target.value)
                          }
                        />
                        <ul>
                          {!multilocationAllLocations && (
                            <li key={-1}>
                              <a
                                onClick={() =>
                                  selectAllLocations(
                                    businessLocation.businessId
                                  )
                                }
                              >
                                {business.name} (All Locations)
                              </a>
                            </li>
                          )}
                          {filteredLocations.map(
                            (businessLocationItem, index) => (
                              <li key={index}>
                                <a
                                  onClick={() =>
                                    selectBusiness(
                                      businessLocationItem.id,
                                      businessLocationItem.businessId
                                    )
                                  }
                                >
                                  {businessLocationItem.locationCode ? (
                                    <span>
                                      <span
                                        className='badge'
                                        style={{
                                          backgroundColor:
                                            businessLocationItem.locationColor ||
                                            theme.darkGray,
                                        }}
                                      >
                                        {businessLocationItem.locationCode}
                                      </span>
                                      {businessLocationItem.name}
                                    </span>
                                  ) : (
                                    businessLocationItem.fullName
                                  )}
                                </a>
                              </li>
                            )
                          )}
                        </ul>
                      </ScrollArea>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* Quick Quotes */}
            {business.permissions.quickViewOrdersEnabled && (
              <div className='quick-view-toggle-container w-120px ml-50 flex-row'>
                <h3 className='bold white center self-center'>Quick Quote</h3>
                <Toggle
                  toggled={isQuickView}
                  onToggle={handleQuickViewToggle}
                  thumbStyle={whiteToggleStyles.thumbOff}
                  trackStyle={whiteToggleStyles.trackOff}
                  thumbSwitchedStyle={whiteToggleStyles.thumbOn}
                  trackSwitchedStyle={whiteToggleStyles.trackOn}
                />
              </div>
            )}
            <ul>
              {/* Orders */}
              {!isQuickView && (
                <li>
                  <NavLink
                    id='nav_dashboard'
                    to={getDashboardNavLinkPath(employeeLocationRelationship)}
                    activeClassName='selected'
                    isActive={(match, location) => {
                      if (
                        match ||
                        (!multilocationAllLocations &&
                          location.pathname.includes('/at-a-glance')) ||
                        location.pathname.includes('dashboard') ||
                        location.pathname.includes('payments/recent') ||
                        location.pathname.includes(
                          'payments/balanceRemaining'
                        ) ||
                        location.pathname.includes('payments/finalBalanceDue')
                      ) {
                        return true;
                      }
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
              )}
              {!isQuickView && multilocationAllLocations ? (
                <li
                  className={classnames({
                    col2: !shouldRender(),
                    col3: shouldRender(),
                    [determineOffset('events')]: true,
                    disabled: true,
                  })}
                >
                  Orders
                </li>
              ) : (
                <>
                  {!isQuickView && (
                    <li
                      className={classnames({
                        eventsMenu: true,
                        col2: !shouldRender(),
                        col3: shouldRender(),
                        [determineOffset('events')]: true,
                      })}
                      onMouseEnter={toggleEventsMenu}
                      onMouseLeave={leaveEventsMenu}
                      onClick={toggleEventsMenu}
                    >
                      <NavLink
                        id='nav_orders'
                        to='/orders'
                        activeClassName='selected'
                      >
                        Orders
                      </NavLink>
                      {events.open && (
                        <div className='subMenu'>
                          <div>
                            <div>
                              <h4>Orders</h4>
                              {shouldRender() && (
                                <ul>
                                  {(business.permissions
                                    .secondaryOrdersEnabled ||
                                    business.permissions
                                      .eventGroupingEnabled) && (
                                    <li>
                                      <Link
                                        id='nav_orders_orders_new_events'
                                        className='add'
                                        to='/orders/events/new'
                                      >
                                        <AddCircle />
                                        Create New Event
                                      </Link>
                                    </li>
                                  )}
                                  {(business.permissions
                                    .cycleBilling) && (
                                      <li>
                                        <Link
                                          id='nav_orders_orders_cycle_billing'
                                          className='add'
                                          to='/orders/events/contracts/new'
                                        >
                                          <AddCircle />
                                          Create New Contract
                                        </Link>
                                      </li>
                                    )}
                                  {business.permissions
                                    .secondaryOrdersEnabled && (
                                    <li>
                                      <Link
                                        id='nav_orders_orders_new_events'
                                        className='add'
                                        to='/orders/parent-orders/new'
                                      >
                                        <AddCircle />
                                        Create {parentOrderSingular}
                                      </Link>
                                    </li>
                                  )}
                                  <li>
                                    <Link
                                      id='nav_orders_orders_new_orders'
                                      className='add'
                                      to='/orders/rentals/new'
                                    >
                                      <AddCircle />
                                      Create New Order
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      id='nav_orders_orders_new_template'
                                      className='add'
                                      to='/orders/rentals/newTemplate'
                                    >
                                      <AddCircle />
                                      Create New Template
                                    </Link>
                                  </li>
                                </ul>
                              )}
                            </div>
                            <ul>
                              {shouldRender() &&
                                (business.permissions.secondaryOrdersEnabled ||
                                  business.permissions
                                    .eventGroupingEnabled) && (
                                  <li>
                                    <Link
                                      id='nav_orders_events_all'
                                      to='/orders/events/all'
                                    >
                                      <AllRentals />
                                      {originalTerminologies().eventPlural}
                                    </Link>
                                  </li>
                                )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_all_orders'
                                    to='/orders/rentals/all'
                                  >
                                    <AllRentals />
                                    All Orders
                                  </Link>
                                </li>
                              )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_open_orders'
                                    to='/orders/rentals/open'
                                  >
                                    <AllRentals />
                                    Open Orders
                                  </Link>
                                </li>
                              )}
                              {checkPermission('operations_view') &&
                                (checkPermission('accept_quote') ||
                                  checkPermission(
                                    'view_reservations_quotes'
                                  )) && (
                                  <li>
                                    <Link
                                      id='nav_orders_orders_pending'
                                      to='/orders/rentals/pending'
                                    >
                                      <Pending />
                                      Pending
                                    </Link>
                                  </li>
                                )}

                              {shouldRender() &&
                                checkPermission('view_reservations_quotes') && (
                                  <li>
                                    <Link
                                      id='nav_orders_orders_quotes'
                                      to='/orders/rentals/quotes'
                                    >
                                      <Quotes />
                                      Quotes
                                    </Link>
                                  </li>
                                )}

                              {(shouldRender() ||
                                checkPermission(
                                  'view_reservations_quotes'
                                )) && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_reservations'
                                    to='/orders/rentals/reservations'
                                  >
                                    <Reservations />
                                    Reservations
                                  </Link>
                                </li>
                              )}
                              <li>
                                <Link
                                  id='nav_orders_orders_checked_out'
                                  to='/orders/rentals/checkedOut'
                                >
                                  <CheckedOut />
                                  {checkedOutSingular}
                                </Link>
                              </li>
                              <li>
                                <Link
                                  id='nav_orders_orders_checked_in'
                                  to='/orders/rentals/checkedIn'
                                >
                                  <CheckedIn />
                                  {checkedInSingular}
                                </Link>
                              </li>
                              {(shouldRender() ||
                                checkPermission('view_closed')) && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_closed_orders'
                                    to='/orders/rentals/closed'
                                  >
                                    <Closed />
                                    Closed Orders
                                  </Link>
                                </li>
                              )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_cancelled_orders'
                                    to='/orders/rentals/cancelled'
                                  >
                                    <Cancelled />
                                    Cancelled Orders
                                  </Link>
                                </li>
                              )}
                            </ul>

                            <ul>
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_alerts'
                                    to='/orders/rentals/alerts'
                                  >
                                    <Alert />
                                    Alerts
                                  </Link>
                                </li>
                              )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_drafts'
                                    to='/orders/rentals/drafts'
                                  >
                                    <Drafts />
                                    Drafts
                                  </Link>
                                </li>
                              )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_orders_orders_templates'
                                    to='/orders/rentals/templates'
                                  >
                                    <Templates />
                                    Templates
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </div>
                          {shouldRender() && (
                            <div>
                              <div>
                                <h4>Subrentals</h4>
                              </div>
                              <ul>
                                {/* <li>
                                <Link
                                  id="nav_orders_suborders_orders_from_connect"
                                  to="/orders/subrentals/fromConnect"
                                >
                                  <Connect />
                                  Orders from Connect
                                </Link>
                              </li>
                              <li>
                                <Link
                                  id="nav_orders_suborders_orders_with_suborders"
                                  to="/orders/subrentals/withSubrentals"
                                >
                                  <WithSubRentals />
                                  Orders with Subrentals
                                </Link>
                              </li> */}
                                <li>
                                  <Link
                                    id='nav_orders_all_subrentals'
                                    to='/todos/inventory/subrentalApprovals'
                                  >
                                    <WithSubRentals />
                                    All Subrentals
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                </>
              )}
              {/* Inventory */}
              {!isQuickView &&
                user &&
                (checkPermission('view_inventory') ||
                  checkPermission('edit_add_inventory')) &&
                (multilocationAllLocations ? (
                  <li
                    className={classnames({
                      inventoryMenu: true,
                      col2: !checkPermission('edit_add_inventory'),
                      col3: checkPermission('edit_add_inventory'),
                      [determineOffset('inventory')]: true,
                      disabled: true,
                    })}
                    onMouseEnter={toggleInventoryMenu}
                    onMouseLeave={leaveInventoryMenu}
                    onClick={toggleInventoryMenu}
                  >
                    Inventory
                  </li>
                ) : (
                  <>
                    {!isQuickView && (
                      <li
                        className={classnames({
                          inventoryMenu: true,
                          col2: !checkPermission('edit_add_inventory'),
                          col3: checkPermission('edit_add_inventory'),
                          [determineOffset('inventory')]: true,
                        })}
                        onMouseEnter={toggleInventoryMenu}
                        onMouseLeave={leaveInventoryMenu}
                        onClick={toggleInventoryMenu}
                      >
                        <NavLink
                          id='nav_inventory'
                          to='/inventory'
                          activeClassName='selected'
                        >
                          Inventory
                        </NavLink>
                        {inventory.open && (
                          <div className='subMenu'>
                            <div>
                              <div>
                                <h4>Inventory</h4>
                                {checkPermission('edit_add_inventory') && (
                                  <ul>
                                    <li>
                                      <Link
                                        id='nav_inventory_add_item'
                                        className='add'
                                        to='/inventory/items/new'
                                      >
                                        <AddCircle />
                                        Add Item
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        id='nav_inventory_add_accessory'
                                        className='add'
                                        to='/inventory/accessories/new'
                                      >
                                        <AddCircle />
                                        Add Accessory
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        id='nav_inventory_add_purchase'
                                        className='add'
                                        to='/inventory/purchases/new'
                                      >
                                        <AddCircle />
                                        Add{' '}
                                        {
                                          originalTerminologies()
                                            .purchaseSingular
                                        }
                                      </Link>
                                    </li>
                                    {business.permissions.bundlesEnabled && (
                                      <li>
                                        <Link
                                          id='nav_inventory_add_bundle'
                                          className='add'
                                          to={'/inventory/bundles/new'}
                                        >
                                          <AddCircle />
                                          Add Bundle
                                        </Link>
                                      </li>
                                    )}
                                  </ul>
                                )}
                              </div>
                              <ul>
                                <li>
                                  <Link
                                    id='nav_inventory_calendar'
                                    to='/inventory/calendar'
                                  >
                                    <Calendar />
                                    Calendar
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    id='nav_inventory_items'
                                    to='/inventory/items'
                                  >
                                    <Items />
                                    Items
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    id='nav_inventory_accessories'
                                    to='/inventory/accessories'
                                  >
                                    <Accessories />
                                    Accessories
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    id='nav_inventory_purchases'
                                    to='/inventory/purchases'
                                  >
                                    <Addons />
                                    {originalTerminologies().purchasePlural}
                                  </Link>
                                </li>
                                {business.permissions.bundlesEnabled && (
                                  <li>
                                    <Link
                                      id='nav_inventory_bundles'
                                      to={'/inventory/bundles'}
                                    >
                                      <Bundles />
                                      Bundles
                                    </Link>
                                  </li>
                                )}
                                {checkPermission('view_inventory_count') && (
                                  <li>
                                    <Link
                                      id='nav_inventory_inventory_count'
                                      to='/inventory/count/items'
                                    >
                                      <Count />
                                      Inventory Count
                                    </Link>
                                  </li>
                                )}

                                {(checkPermission('edit_add_inventory') || checkPermission('move_serialized_inventory_to_another_location')) && (
                                  <li>
                                    <Link
                                      id='nav_inventory_inventory_count'
                                      to='/inventory/moveSerializedInventory'
                                    >
                                      <Barcode />
                                      Move Serialized Inventory
                                    </Link>
                                  </li>
                                )}
                                {checkPermission(
                                  'access_to_inventory_maintenance'
                                ) && (
                                  <li>
                                    <Link
                                      id='nav_inventory_maintenance'
                                      to='/inventory/maintenance'
                                    >
                                      <Maintenance />
                                      Maintenance
                                    </Link>
                                  </li>
                                )}
                                {business.permissions.purchaseOrdersEnabled && (
                                  <li>
                                    <Link
                                      id='nav_inventory_purchase_orders'
                                      to={'/inventory/purchase_orders'}
                                    >
                                      <PurchaseOrderFilled />
                                      Purchase Orders
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        )}
                      </li>
                    )}
                  </>
                ))}
              {/* Contacts */}
              {!isQuickView &&
                user &&
                (checkPermission('view_contacts') ||
                  checkPermission('edit_add_contacts')) &&
                (multilocationAllLocations ? (
                  <li
                    className={classnames({
                      contactsMenu: true,
                      col1: !checkPermission('edit_add_contacts'),
                      col2: checkPermission('edit_add_contacts'),
                      [determineOffset('contacts')]: true,
                      disabled: true,
                    })}
                    onMouseEnter={toggleContactsMenu}
                    onMouseLeave={leaveContactsMenu}
                    onClick={toggleContactsMenu}
                  >
                    Contacts
                  </li>
                ) : (
                  <>
                    {!isQuickView && (
                      <li
                        className={classnames({
                          contactsMenu: true,
                          col1: !checkPermission('edit_add_contacts'),
                          col2: checkPermission('edit_add_contacts'),
                          [determineOffset('contacts')]: true,
                        })}
                        onMouseEnter={toggleContactsMenu}
                        onMouseLeave={leaveContactsMenu}
                        onClick={toggleContactsMenu}
                      >
                        <NavLink
                          id='nav_contacts'
                          to='/contacts'
                          activeClassName='selected'
                        >
                          Contacts
                        </NavLink>
                        {contacts.open && (
                          <div className='subMenu'>
                            <div>
                              <div>
                                <h4>Contacts</h4>
                                {checkPermission('edit_add_contacts') && (
                                  <ul>
                                    <li>
                                      <Link
                                        id='nav_contacts_add_customer'
                                        className='add'
                                        to='/contacts/customers/new'
                                        onClick={(event) =>
                                          permissionGate(
                                            event,
                                            'add_new_contacts',
                                            PERMISSION_ERROR_MESSAGES[
                                              'add_new_contacts'
                                            ]
                                          )
                                        }
                                      >
                                        <AddCircle />
                                        Add Customer
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        id='nav_contacts_add_company'
                                        className='add'
                                        to='/contacts/companies/new'
                                        onClick={(event) =>
                                          permissionGate(
                                            event,
                                            'add_new_contacts',
                                            PERMISSION_ERROR_MESSAGES[
                                              'add_new_contacts'
                                            ]
                                          )
                                        }
                                      >
                                        <AddCircle />
                                        Add Company
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        id='nav_contacts_add_venue'
                                        className='add'
                                        to='/contacts/venues/new'
                                        onClick={(event) =>
                                          permissionGate(
                                            event,
                                            'add_new_contacts',
                                            PERMISSION_ERROR_MESSAGES[
                                              'add_new_contacts'
                                            ]
                                          )
                                        }
                                      >
                                        <AddCircle />
                                        Add {venueSingular}
                                      </Link>
                                    </li>
                                  </ul>
                                )}
                              </div>
                              <ul>
                                <li>
                                  <Link
                                    id='nav_contacts_customers'
                                    to='/contacts/customers'
                                  >
                                    <Team />
                                    Customers
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    id='nav_contacts_companies'
                                    to='/contacts/companies'
                                  >
                                    <Company />
                                    Companies
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    id='nav_contacts_venues'
                                    to='/contacts/venues'
                                  >
                                    <Venue />
                                    {venuePlural}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                      </li>
                    )}
                  </>
                ))}
              {/* Operations */}
              {!isQuickView && multilocationAllLocations ? (
                <li
                  className={classnames({
                    operationsMenu: true,
                    col1: true,
                    [determineOffset('operations')]: true,
                    disabled: true,
                  })}
                  onMouseEnter={toggleOperationsMenu}
                  onMouseLeave={leaveOperationsMenu}
                  onClick={toggleOperationsMenu}
                >
                  Operations
                </li>
              ) : (
                <>
                  {!isQuickView && (
                    <li
                      className={classnames({
                        operationsMenu: true,
                        col1: true,
                        [determineOffset('operations')]: true,
                      })}
                      onMouseEnter={toggleOperationsMenu}
                      onMouseLeave={leaveOperationsMenu}
                      onClick={toggleOperationsMenu}
                    >
                      <NavLink
                        id='nav_operations'
                        to='/operations'
                        activeClassName='selected'
                      >
                        Operations
                      </NavLink>
                      {operations.open && (
                        <div className='subMenu'>
                          {checkPermission('view_routing') &&
                            business.showRoutingAssignments &&
                            business.permissions.routingAndTrackingEnabled && (
                              <div>
                                <div>
                                  <h4>Routing</h4>
                                  <ul>
                                    <li>
                                      <Link
                                        id='nav_operations_routing_add_truck'
                                        className='add'
                                        to={'/admin/settings/routing'}
                                      >
                                        <AddCircle />
                                        Add Truck
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_operations_routing_schedule'
                                      to={'/operations/routing/calendar'}
                                    >
                                      <Calendar />
                                      Calendar
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to={'/operations/routing/orders'}>
                                      <AllRentals />
                                      Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      id='nav_operations_routing_map'
                                      to={'/operations/routing/map'}
                                    >
                                      <Map />
                                      Map
                                    </Link>
                                  </li>
                                  {business.permissions.gpsEnabled && (
                                    <li>
                                      <Link
                                        id='nav_operations_routing_gps'
                                        to={'/operations/routing/gps'}
                                      >
                                        <GpsMarker />
                                        GPS
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}
                          <div>
                            <div>
                              <h4>Warehouse</h4>
                            </div>
                            <ul>
                              <li>
                                <Link
                                  id='nav_operations_warehouse_checking_out'
                                  to='/operations/warehouse/checkingOut'
                                >
                                  <CheckingOut />
                                  {checkingOutSingular}
                                </Link>
                              </li>
                              <li>
                                <Link
                                  id='nav_operations_warehouse_checking_in'
                                  to='/operations/warehouse/checkingIn'
                                >
                                  <CheckingIn />
                                  {checkingInSingular}
                                </Link>
                              </li>
                            </ul>
                          </div>

                          {checkPermission('view_edit_staffing') && (
                            <div>
                              <div>
                                <h4>Staffing</h4>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_operations_staffing_add_staff_member'
                                      className='add'
                                      to='/operations/staff/members/new'
                                    >
                                      <AddCircle />
                                      Add Staff Member
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              <ul>
                                {checkPermission('view_edit_nowsta') && (
                                  <li>
                                    <Link
                                      id='nav_operations_staffing_nowsta'
                                      to='/operations/staff/nowsta'
                                    >
                                      <NowstaLogo color={'#278ADA'} />
                                      Nowsta
                                    </Link>
                                  </li>
                                )}
                                <li>
                                  <Link
                                    id='nav_operations_staffing_schedule'
                                    to='/operations/staff/calendar'
                                  >
                                    <Calendar />
                                    Schedule
                                  </Link>
                                </li>
                                {checkPermission('view_add_remove_staff') && (
                                  <li>
                                    <Link
                                      id='nav_operations_staffing_staff_members'
                                      to='/operations/staff/members'
                                    >
                                      <Team />
                                      Staff Members
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}

                          <div>
                            <div>
                              <h4>Services</h4>
                              <ul>
                                <li>
                                  <Link
                                    id='nav_operations_staffing_add_staff_member'
                                    className='add'
                                    to='/operations/services/new'
                                  >
                                    <AddCircle />
                                    Add Service
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <ul>
                              <li>
                                <Link
                                  id='nav_operations_staffing_nowsta'
                                  to='/operations/services'
                                >
                                  <Roles color={'#278ADA'} />
                                  Services
                                </Link>
                              </li>
                              {business.permissions
                                .recurringServicesEnabled && (
                                <li>
                                  <Link
                                    id='nav_operations_staffing_schedule'
                                    to={'/operations/recurrences'}
                                  >
                                    <Clock />
                                    Recurrences
                                  </Link>
                                </li>
                              )}
                              {business.permissions.secondaryOrdersEnabled && (
                                <li>
                                  <Link
                                    id='nav_operations_staffing_nowsta'
                                    to={'/operations/labors'}
                                  >
                                    <BlueClock />
                                    Labors
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </div>

                          <div>
                            <div>
                              <h4>Calendars</h4>
                            </div>
                            <ul>
                              {shouldRender() &&
                                business.permissions.availabilityCalendars && (
                                  <li>
                                    <Link
                                      to={'/operations/calendars/availability'}
                                    >
                                      <Calendar />
                                      Availability
                                    </Link>
                                  </li>
                                )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_operations_calendars_orders'
                                    to='/operations/calendars/calendar'
                                  >
                                    <AllRentals />
                                    Orders
                                  </Link>
                                </li>
                              )}
                              {shouldRender() && (
                                <li>
                                  <Link
                                    id='nav_operations_calendars_alerts'
                                    to='/operations/calendars/alerts'
                                  >
                                    <Alert />
                                    Alerts
                                  </Link>
                                </li>
                              )}

                              <li>
                                <Link
                                  id='nav_operations_calendars_drop_off_pick_up'
                                  to='/operations/calendars/dropOff-pickUp'
                                >
                                  <TruckDropOff />
                                  Drop Off/Pick Up
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {checkPermission('view_picklist_manager') &&
                            business.permissions.flowSheetEnabled && (
                              <div>
                                <div>
                                  <h4>
                                    {pickListManagerFeatureName(business.id)}
                                  </h4>
                                </div>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_operations_flowsheet_orders'
                                      to={'/operations/flowsheet/orders'}
                                    >
                                      <RentalSettings />
                                      {pickListManagerFeatureName(business.id)}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                        </div>
                      )}
                    </li>
                  )}
                </>
              )}
              {/* Admin */}
              {!isQuickView &&
                (checkPermission('view_reports') ||
                  checkPermission('view_edit_settings')) &&
                (multilocationAllLocations ? (
                  <li
                    className={classnames({
                      adminMenu: true,
                      col3: true,
                      [determineOffset('admin')]: true,
                      disabled: true,
                    })}
                    onMouseEnter={toggleAdminMenu}
                    onMouseLeave={leaveAdminMenu}
                    onClick={toggleAdminMenu}
                  >
                    Admin
                  </li>
                ) : (
                  <>
                    {!isQuickView && (
                      <li
                        className={classnames({
                          adminMenu: true,
                          col3: true,
                          [determineOffset('admin')]: true,
                        })}
                        onMouseEnter={toggleAdminMenu}
                        onMouseLeave={leaveAdminMenu}
                        onClick={toggleAdminMenu}
                      >
                        <NavLink
                          id='nav_admin'
                          to='/admin'
                          activeClassName='selected'
                        >
                          Admin
                        </NavLink>
                        {admin.open && (
                          <div className='subMenu adminLgMenu'>
                            {checkPermission('view_edit_settings') && (
                              <div>
                                <div>
                                  <h4>Storefront</h4>
                                </div>
                                <ul className='empty-without-li'>
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/domain',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_domain_settings'
                                        to='/admin/storefront/domain'
                                      >
                                        <RentalSettings />
                                        Domain Settings
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/pages/shop',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_shop_cart_settings'
                                        to='/admin/storefront/pages/shop'
                                      >
                                        <CartIcon />
                                        Shop + Cart
                                      </Link>
                                    </li>
                                  )}
                                  {business.permissions
                                    .customizableDesignAndContent && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_themes'
                                        to={'/admin/storefront/themes'}
                                      >
                                        <Layout />
                                        Themes
                                      </Link>
                                    </li>
                                  )}
                                  {business.permissions
                                    .customizableDesignAndContent && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_styling'
                                        to={'/admin/storefront/styling'}
                                      >
                                        <Styling />
                                        Styling
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                                <ul>
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/pages/shop',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_pages'
                                        to='/admin/storefront/pages/shop'
                                      >
                                        <Pages />
                                        Pages
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/menu',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_menu'
                                        to='/admin/storefront/menu'
                                      >
                                        <MenuIcon />
                                        Menu
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/testimonials',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_testimonials'
                                        to='/admin/storefront/testimonials'
                                      >
                                        <MessageBubble />
                                        Testimonials
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/pages/orders',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_orders'
                                        to='/admin/storefront/pages/orders'
                                      >
                                        <OrderBag />
                                        My Orders
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                                <ul>
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/socialMedia',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_social_media'
                                        to='/admin/storefront/socialMedia'
                                      >
                                        <ThumbsUp />
                                        Social Media
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/footer',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_footer'
                                        to='/admin/storefront/footer'
                                      >
                                        <Footer />
                                        Footer
                                      </Link>
                                    </li>
                                  )}
                                  {!storefrontSettingLocked(
                                    '/admin/storefront/seo',
                                    businessLocation.sfSubscriptionTier
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_seo_tracking'
                                        to='/admin/storefront/seo'
                                      >
                                        <Profit />
                                        Global SEO + Tracking
                                      </Link>
                                    </li>
                                  )}
                                  {business.permissions
                                    .wordPressFeatureEnabled && (
                                    <li>
                                      <Link
                                        id='nav_admin_storefront_wordpress'
                                        to={'/admin/storefront/wordpress'}
                                      >
                                        <RentalSettings />
                                        WordPress Plugin
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}

                            {checkPermission('view_edit_settings') && (
                              <div>
                                <div>
                                  <h4>Templates</h4>
                                </div>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_admin_template_proposals'
                                      to='/admin/templates/proposal_templates'
                                    >
                                      <Proposals />
                                      Proposals
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            )}

                            {checkPermission('view_reports') && (
                              <div>
                                <div>
                                  <h4>Reports</h4>
                                </div>
                                {reportLinkColumns(
                                  business.multilocationReportsEnabled,
                                  business.permissions.generalLedgerEnabled ||
                                    business.permissions
                                      .simplifiedGeneralLedger,
                                  business.permissions.robustAndCustomReports,
                                  business.permissions.quickbooksIntegration,
                                  business.permissions.npsCustomerSurveys,
                                  business.permissions.tapwiseEnabled,
                                ).map((columnLinks, index) => (
                                  <ul key={index}>
                                    {renderLinks(columnLinks)}
                                  </ul>
                                ))}
                              </div>
                            )}

                            {checkPermission('view_edit_settings') && (
                              <div>
                                <div>
                                  <h4>Settings</h4>
                                </div>
                                <ul>
                                  {checkPermission(
                                    'access_settings_location'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_location'
                                        to='/admin/settings/location'
                                      >
                                        <Business />
                                        Location
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission(
                                    'access_settings_account'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_account'
                                        to='/admin/settings/account'
                                      >
                                        <Receipt />
                                        Account
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission('access_settings_team') && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_team'
                                        to='/admin/settings/team'
                                      >
                                        <Team />
                                        Team
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission('access_settings_order') && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_order'
                                        to='/admin/settings/order'
                                      >
                                        <RentalSettings />
                                        Order
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission(
                                    'access_settings_payments'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_payments'
                                        to={paymentsUrl(
                                          businessLocation.paymentProcessor
                                        )}
                                      >
                                        <Payment />
                                        Payments
                                      </Link>
                                    </li>
                                  )}
                                  {(checkPermission('gl_mapping_admin') &&
                                    checkPermission(
                                      'access_settings_reports'
                                    ) &&
                                    business.permissions
                                      .generalLedgerEnabled) ||
                                    (business.permissions
                                      .simplifiedGeneralLedger && (
                                      <li>
                                        <Link
                                          id='nav_admin_settings_reports'
                                          to={
                                            business.permissions
                                              .generalLedgerEnabled ||
                                            business.permissions
                                              .simplifiedGeneralLedger
                                              ? '/admin/settings/reports/generalLedger'
                                              : '/upgrade/generalLedger'
                                          }
                                        >
                                          <Profit />
                                          Reports
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                                <ul>
                                  {checkPermission(
                                    'access_settings_inventory'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_inventory'
                                        to='/admin/settings/inventory'
                                      >
                                        <Items />
                                        Inventory
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission(
                                    'access_settings_contacts'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_inventory'
                                        to='/admin/settings/contacts'
                                      >
                                        <Contacts />
                                        Contacts
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission(
                                    'access_settings_zapier'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_zapier'
                                        to='/admin/settings/zapier'
                                      >
                                        <Zapier />
                                        Zapier
                                      </Link>
                                    </li>
                                  )}
                                  {business.permissions.tapgoodsConnect &&
                                    checkPermission(
                                      'access_settings_tg_connect'
                                    ) && (
                                      <li>
                                        <Link
                                          id='nav_admin_settings_tapgoods_connect'
                                          to='/admin/settings/connectDefaults'
                                        >
                                          <Connect />
                                          TapGoods Connect
                                        </Link>
                                      </li>
                                    )}
                                  {checkPermission(
                                    'access_settings_financial'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_financial_settings'
                                        to='/admin/settings/financialSettings'
                                      >
                                        <RentalSettings />
                                        Financial Settings
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission('access_settings_email') && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_email'
                                        to='/admin/settings/email'
                                      >
                                        <Email />
                                        Email
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                                <ul>
                                  {checkPermission('access_settings_legal') && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_legal'
                                        to='/admin/settings/legal'
                                      >
                                        <LegalDocument />
                                        Legal
                                      </Link>
                                    </li>
                                  )}
                                  {checkPermission('access_settings_routing') &&
                                    business.permissions
                                      .routingAndTrackingEnabled && (
                                      <li>
                                        <Link
                                          id='nav_admin_settings_routing'
                                          to={'/admin/settings/routing'}
                                        >
                                          <TruckDropOff />
                                          Routing
                                        </Link>
                                      </li>
                                    )}
                                  {checkPermission(
                                    'access_settings_terminology'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_terminology'
                                        to='/admin/settings/terminology'
                                      >
                                        <LegalDocument />
                                        Terminology
                                      </Link>
                                    </li>
                                  )}
                                  <li>
                                    <Link to='/admin/settings/print'>
                                      <Print />
                                      Print
                                    </Link>
                                  </li>
                                  {checkPermission(
                                    'access_settings_picklist'
                                  ) && (
                                    <li>
                                      <Link
                                        id='nav_admin_settings_order'
                                        to='/admin/settings/picklist'
                                      >
                                        <TickMark />
                                        Picklist
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}

                            {checkPermission('access_admin_payment_terms') && creditTermsEnabled && (
                              <div>
                                <div>
                                  <h4>Payment Terms</h4>
                                </div>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_admin_payment_terms_accounts_receivable'
                                      to='/admin/payment_terms/accounts_receivable'
                                    >
                                      <Export />
                                      Accounts Receivable
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      id='nav_admin_payment_terms_statements'
                                      to='/admin/payment_terms/statements'
                                    >
                                      <QuickbooksCircle />
                                      Statements
                                    </Link>
                                  </li>
                                </ul>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_admin_payment_terms_ar_aging'
                                      to='/admin/payment_terms/ar_aging'
                                    >
                                      <Export />
                                      AR Aging
                                    </Link>
                                  </li>
                                </ul>
                                <ul>
                                  <li>
                                    <Link
                                      id='nav_admin_payment_terms_credit_debit_memos'
                                      to='/admin/payment_terms/credit_debit_memos'
                                    >
                                      <Receipt />
                                      Credit & Debit Memos
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                            {canViewMultilocation &&
                              business.multilocationEnabled && (
                                <div>
                                  <div>
                                    <h4>Multilocation</h4>
                                  </div>
                                  <ul>
                                    {checkPermission(
                                      'view_edit_ml_locations'
                                    ) && (
                                      <li>
                                        <Link
                                          id='nav_admin_multilocation_locations'
                                          to='/admin/multilocation/locations'
                                        >
                                          <Business />
                                          Locations
                                        </Link>
                                      </li>
                                    )}
                                    {checkPermission(
                                      'view_edit_ml_settings'
                                    ) && (
                                      <li>
                                        <Link
                                          id='nav_admin_multilocation_settings'
                                          to='/admin/multilocation/settings'
                                        >
                                          <RentalSettings />
                                          Settings
                                        </Link>
                                      </li>
                                    )}
                                  </ul>
                                  {checkPermission('view_edit_ml_account') && (
                                    <ul>
                                      <li>
                                        <Link
                                          id='nav_admin_multilocation_account'
                                          to='/admin/multilocation/account'
                                        >
                                          <Receipt />
                                          Account
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                  {checkPermission('view_edit_ml_team') &&
                                    checkPermission(
                                      'access_to_team_multilocation'
                                    ) && (
                                      <ul>
                                        <li>
                                          <Link
                                            id='nav_admin_multilocation_team'
                                            to='/admin/multilocation/team'
                                          >
                                            <Team />
                                            Team
                                          </Link>
                                        </li>
                                      </ul>
                                    )}
                                </div>
                              )}
                          </div>
                        )}
                      </li>
                    )}
                  </>
                ))}
              {/* Messages */}
              {!isQuickView &&
                user &&
                user.role !== 'devops' &&
                businessLocation &&
                businessLocation.id && <MessagesTab />}
              {/* Profile */}
              <li
                className={classnames({
                  profileMenu: true,
                  col3: true,
                })}
                onMouseEnter={toggleProfileMenu}
                onMouseLeave={leaveProfileMenu}
                onClick={toggleProfileMenu}
              >
                <div className='imageWrapper'>
                  {user.picture ? (
                    <Imgix
                      src={user.picture.imgixUrl}
                      alt={user.firstName}
                      height={200}
                      width={200}
                    />
                  ) : (
                    <div>
                      {user.firstName.charAt(0)}
                      {user.lastName.charAt(0)}
                    </div>
                  )}
                </div>
                {profile.open ? <ArrowUp /> : <ArrowDown />}
                {profile.open && (
                  <div className='subMenu'>
                    <div>
                      <div>
                        <h4>My Profile</h4>
                      </div>
                      <ul>
                        <li>
                          <a
                            id='nav_profile_terms_and_conditions'
                            href='//www.tapgoods.com/pro/terms-conditions/'
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            Terms & Conditions
                          </a>
                        </li>
                        <li>
                          <a
                            id='nav_profile_privacy_policy'
                            href='//www.tapgoods.com/pro/privacy-policy/'
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            Privacy Policy
                          </a>
                        </li>
                        <li>
                          <a
                            id='nav_profile_tapgoods_capital'
                            href='https://tapgoods-capital.webflow.io/'
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            TapGoods Capital
                          </a>
                        </li>
                      </ul>
                      <ul>
                        {checkPermission('import_wizard') &&
                          business.permissions.importWizardEnabled && (
                            <li>
                              <Link id='nav_import_wizard' to={'/importWizard'}>
                                Import Wizard
                              </Link>
                            </li>
                          )}
                        <li>
                          <Link
                            id='nav_profile_support'
                            to='/support'
                            onClick={myProfileSupportOnClick}
                          >
                            Support
                          </Link>
                        </li>
                        <li>
                          <a
                            id='nav_profile_schedule_a_demo'
                            target='_blank'
                            href='https://www.tapgoods.com/pro/demo/'
                            rel='noopener noreferrer'
                          >
                            Schedule a Demo
                          </a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <Link id='nav_profile_my_profile' to='/profile'>
                            My Profile
                          </Link>
                        </li>
                        {user.role !== 'warehouse_manager' &&
                          user.role !== 'devops' && (
                            <li>
                              <a
                                id='nav_profile_my_storefront'
                                href={cpHostName(businessLocation)}
                                target='_blank'
                              >
                                My Storefront
                              </a>
                            </li>
                          )}
                        <li>
                          <a
                            id='nav_profile_sign_out'
                            onClick={signOutUser}
                            className='highlight'
                          >
                            Sign Out
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </li>
            </ul>
            {!isRentalsV2Path() && (
              <QuickViewModal
                isOpen={isQuickViewModalOpen}
                onClose={handleCloseQuickViewModal}
              />
            )}
          </div>
        </div>
      }
      mobile={
        <MobileSignedInNav
          signOutUser={signOutUser}
          selectBusiness={selectBusiness}
        />
      }
    />
  );
};

SignedInNav.propTypes = {
  signOutUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { errors, loading } = state.auth;
  const { business } = state.business;
  const { location: businessLocation } = state.location;
  const { multilocationAllLocations } = state.dashboard;
  const { originalTerminologies, terminologies } = state.terminology;
  const { unreadMessages } = state.conversationList;
  const { isQuickView } = state.quickView;
  const { user, employeeLocationRelationship } = state.user;

  const checkPermission = selectCheckPermission(state);

  return {
    errors,
    loading,
    business,
    businessLocation,
    multilocationAllLocations,
    originalTerminologies,
    terminologies,
    user,
    unreadMessages,
    checkPermission,
    employeeLocationRelationship,
    isQuickView,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    ...actions,
    setQuickView,
    setMultilocationAllLocations,
  })(SignedInNav)
);
